<div id="main-wrapper">

  <!-- Header
    ============================================= -->
  <app-header></app-header>
  <!-- Header end -->

  <!-- Page Header
      ============================================= -->
  <section class="page-header page-header-text-light bg-secondary">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-8">
          <h1>Control Center to Manage your Portal</h1>
        </div>
      </div>
    </div>
  </section><!-- Page Header end -->

  <!-- Content
    ============================================= -->
  <div id="content">
    <div class="container">
      <div class="bg-light shadow-md rounded p-4">
        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-8"> </div>
            <div class="col-sm-4 ">
              <select [(ngModel)]="reportType" class="form-control text-3" (change)="search()">
                <option value="">Select Dashboard Option</option>
                <option value="CruiseMarkupManagement"> Cruise Markup Management</option>
                <option value="CruiseBalance">Cruise Balance</option>
                <option value="DailyROE">Daily ROE</option>
              </select>
            </div>
          </div>
        </div>
        <hr class=" mt-4 mb-4">
        <div class="text-center">
          <h5>{{this.reportname}}</h5>
        </div>
        <div class="tab-content my-3" id="myTabContent">

          <div id="CruiseMarkupManagement" class="table-responsive-md disabledbutton">
            <div class="table-responsive-md">
              <table class="table table-hover border">
                <thead class="thead-light">
                  <tr>
                    <th>Cruise Line</th>
                    <th>Commission (in %)</th>
                    <th>Commission (in value)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let Markup of CruiseMarkUps;let i = index">
                    <td class="align-middle">{{Markup.code}}</td>
                    <td class="align-middle">
                      <input class="text-right" name="CommPerc{{i}}" [(ngModel)]="Markup.CommPerc" id="CommPerc{{i}}"
                        ng-required="true" type="text" (keypress)="isNumberKeyDec($event)">
                    </td>
                    <td class="align-middle">
                      <input class="text-right" name="Comm{{i}}" [(ngModel)]="Markup.Comm" id="Comm{{i}}"
                        ng-required="true" type="text" (keypress)="isNumberKeyDec($event)">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-sm-12 text-center">
              <button (click)="Updatemarkupcruise()" class="btn btn-primary">Update</button>
            </div>
          </div>

          <div id="CruiseBalance" class="table-responsive-md disabledbutton">
            <div class="table-responsive-md">
              <table class="table table-hover border">
                <thead class="thead-light">
                  <tr>
                    <th>S No</th>
                    <th>Supplier </th>
                    <th class="text-right">Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let ABala of CruiseBalances;let i = index">
                    <td class="text-left">{{i+1}}.</td>
                    <td class="align-middle">{{ABala.Supplier}}</td>
                    <td class="text-right">{{ABala.Balance}} </td>
                  </tr>
                </tbody>
              </table>
              <table class="table table-hover border">
                <thead class="thead-light">
                  <tr>
                    <th>S No</th>
                    <th>Confirmation</th>
                    <th class="text-right">Booked</th>
                    <th class="text-right">Check-In</th>
                    <th class="text-right">Amount</th>
                    <th class="text-right">Paid</th>
                    <th class="text-right">Pending</th>
                    <th class="text-right">Voucher</th>
                    <th class="text-right">Invoice</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let ABala of CruiseOrgList;let i = index">
                    <td class="text-left">{{i+1}}.</td>
                    <td class="align-middle">{{ABala.number}}</td>
                    <td class="text-right">{{ABala.booked_on}}</td>
                    <td class="text-right">{{ABala.web_checkin_completed}}</td>
                    <td class="text-right">{{ABala.total_amount | number}}</td>
                    <td class="text-right">{{ABala.amount_paid | number}}</td>
                    <td class="text-right">{{ABala.pending_amount | number}}</td>
                    <td class="text-right"><span><a class="red" href="{{ABala.evoucher_url}}"
                          target="_blank">Voucher</a></span></td>
                    <td class="text-right"><span><a class="red" href="{{ABala.invoice_url}}"
                          target="_blank">Invoice</a></span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- <div id="SIMCommission" class="table-responsive-md disabledbutton">
            <div class="row">
              <div class="col-sm-4">
                <div class="form-row">
                  <div class="col-md-4 col-lg-4 mt-2 form-group">
                    <span class="text-2 ">Select Category:</span>
                  </div>
                  <div class="col-md-8 col-lg-8 form-group">
                    <select class="form-control ng-untouched ng-pristine ng-invalid" [(ngModel)]="catecruise"
                      name="catecruise" required="true" (change)="changeTypescru($event)">
                      <option [selected]="true" value="">All Categories</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                      <option value="C">C</option>
                      <option value="D">D</option>
                      <option value="E">E</option>
                      <option value="F">F</option>
                      <option value="G">G</option>
                      <option value="H">H</option>
                      <option value="I">I</option>
                      <option value="J">J</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-2"></div>
              <div class="col-sm-6">
                <div class="form-row">
                  <div class="col-md-3 col-lg-3 mt-2 form-group">
                    <span class="text-2 ">Name/Code/Email&nbsp;&nbsp;:</span>
                  </div>
                  <div class="col-md-9 col-lg-9 form-group">
                    <div class="autocomplete">
                      <input type="text" class="form-control" name="LoginNamecruise" (click)="makeItBlank($event)"
                        [(ngModel)]="LoginNamecruise" placeholder="Select Login Name"
                        (keyup)="changeLoginNamecru($event)" autocomplete="off">
                      <div id="autocomplete-list" class="autocomplete-items autocomplete-item text-left">
                        <div *ngFor="let RName of ResLoginNamecru;"
                          (click)="setLoginNamecru(RName.ContactPerson,RName.uid,RName.sid)">
                          <strong>{{RName.ContactPerson}}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive-md">
              <table class="table table-hover border">
                <thead class="thead-light">
                  <tr>
                    <th>Cruise Line</th>
                    <th>Commission (in %)</th>
                    <th>Commission (in value)</th>
                    <th>Markup (in %)</th>
                    <th>Markup (in value)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let Markup of SIMMarkUps;let i = index">
                    <td class="align-middle">{{Markup.code}}</td>
                    <td class="align-middle">
                      <input class="text-right" name="CommPerc{{i}}" [(ngModel)]="Markup.CommPerc" id="CommPerc{{i}}"
                        ng-required="true" type="text" (keypress)="isNumberKeyDec($event)">
                    </td>
                    <td class="align-middle">
                      <input class="text-right" name="Comm{{i}}" [(ngModel)]="Markup.Comm" id="Comm{{i}}"
                        ng-required="true" type="text" (keypress)="isNumberKeyDec($event)">
                    </td>
                    <td class="align-middle">
                      <input class="text-right" name="MarkPerc{{i}}" [(ngModel)]="Markup.MarkPerc" id="MarkPerc{{i}}"
                        ng-required="true" type="text" (keypress)="isNumberKeyDec($event)">
                    </td>
                    <td class="align-middle">
                      <input class="text-right" name="MarkUp{{i}}" [(ngModel)]="Markup.Markup" id="MarkUp{{i}}"
                        ng-required="true" type="text" (keypress)="isNumberKeyDec($event)">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-sm-12 text-center">
              <button (click)="UpdateSIMMarkup()" class="btn btn-primary">Update</button>
            </div>
          </div> -->

          <div id="DailyROE" class="table-responsive-md disabledbutton">
            <div class="col-sm-4  text-center" style="margin: auto;">
              <form id="changePasswordfrm" method="post">
                <div class="form-group ">
                  <input type="text" class="form-control" name="usdRate" [(ngModel)]="usdRate" data-bv-field="usdRate"
                    id="usdRate" required placeholder="USD Rate">
                </div>
                <div class="form-group">
                  <input type="text" class="form-control" name="eurRate" [(ngModel)]="eurRate" data-bv-field="eurRate"
                    id="eurRate" required placeholder="EUR Rate">
                </div>
                <button (click)="SubmitRate()" class="btn btn-primary align-middle" type="Submit">Submit</button>
              </form>
            </div>
            <table class="table table-hover border">
              <thead class="thead-light">
                <tr>
                  <th>S No</th>
                  <th>Date</th>
                  <th class="text-right">USD</th>
                  <th class="text-right">EUR</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let ABala of roeList;let i = index">
                  <td class="text-left">{{i+1}}.</td>
                  <td class="align-middle">{{ABala.updatedate}}</td>
                  <td class="text-right">{{ABala.usd}}</td>
                  <td class="text-right">{{ABala.eur}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div><!-- Content end -->

  <!-- Footer
    ============================================= -->
  <app-footer></app-footer>
  <!-- Footer end -->

</div>